export class Cabecalho {
    idCabecalho: number;
    idProjeto: number;
    nome: string;
    html: string;
    idDataset: number;
    nomeDataset:string;
}
